<template>
  <modal ref="modal" modal-id="confirm-not-attending-modal" size="sm" headerless :show-on-mount="true">
    <template #body>
      <p>{{ i18n.t('events.show.update_to_not_attending_confirm_for_closed_event') }}</p>

      <div class="d-flex justify-content-between">
        <light-button :label="i18n.t('administrative.cancel')" @click="closeModal" />
        <primary-button :label="i18n.t('administrative.confirm_button')" @click="confirmChange" />
      </div>
    </template>
  </modal>
</template>

<script>
import LightButton from '@/components/buttons/light-button'
import Modal from '@/components/modal'
import { NOT_ATTENDING } from './attending-statuses'
import PrimaryButton from '@/components/buttons/primary-button'

export default {
  components: { LightButton, Modal, PrimaryButton },

  methods: {
    closeModal() {
      this.$refs.modal.close()
      this.$store.commit('hideConfirmNotAttendingModal')
    },

    confirmChange() {
      this.$store.dispatch('updateAttendee', { attendingStatus: NOT_ATTENDING })
      this.closeModal()
    }
  }
}
</script>
